<button
  placement="bottom"
  [autoClose]="'outside'"
  #p="ngbPopover"
  [ngbPopover]="popContent"
  [popoverTitle]="popHeader"
  [triggers]="'manual'"
  (click)="p.open()"
  class="btn btn-primary">
  <i *ngIf="buttonIcon != ''" class="fas {{ buttonIcon }}"></i> {{ buttonText }}
  <i class="fas fa-chevron-down"></i>
</button>
<ng-template #popHeader>
  <div class="row">
    <div class="col-12 text-center vertical-align-center d-flex justify-content-between">
      <button
        [disabled]="disableAll || disableDecrementYear"
        (click)="decrementYear()"
        type="button"
        class="btn btn-link p-0">
        <i class="fas fa-chevron-left"></i>
      </button>
      <span>{{ year }}</span>
      <button
        [disabled]="disableAll || disableIncrementYear"
        (click)="incrementYear()"
        class="btn btn-link p-0"
        type="button">
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>
  </div>
</ng-template>
<ng-template #popContent>
  <div class="d-flex justify-content-between flex-wrap">
    <ng-container *ngFor="let optionButton of availableButtons; let i = index">
      <div style="width: {{ width }}" class="border-end text-center">
        <button
          (click)="choose(optionButton.value)"
          [class.active]="value == optionButton.value"
          [disabled]="optionButton.isDisabled(optionButton.value)"
          class="btn btn-link">
          {{ optionButton.text }}
        </button>
      </div>
      <span class="break" *ngIf="(i + 1) % columns === 0"></span>
    </ng-container>
  </div>
</ng-template>
